<template>
  <div>
    <div v-if="mode==='pc'">
      <PCMe></PCMe>
    </div>
    <div v-if="mode==='mobile'">
      <MobileMe></MobileMe>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PCMe from "@/components/pc/PCMe";
import MobileMe from "@/components/mobile/mobileMe";
import { setUserInfo } from '@/js/utils'
export default {
  data() {
    return {
      wxAppData: "",
      ifstaff: ""
    };
  },
  components: {
    PCMe,
    MobileMe
  },
  computed: {
    mode() {
      return this.$store.state.mode;
    }
  },
  mounted() {
  
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/me.vue